import UNINITIALISED from "utils/uninitialised";
import ActionTypes from "../constants/action_types";
import UserActionTypes from "modules/user/constants/action_types";
import {MaybeUninitialised} from "modules/redux_types";
import {FetchIssueOverrideTagsAction} from "../actions/fetch";
import {IssueOverrideTag} from "common/types/issue_override_tag";
import {ClearIssueOverrideTagsAction} from "../actions/clear";
import {RemoveIssueOverrideTagAction} from "../actions/remove";
import {UpdateIssueOverrideTagAction} from "../actions/update";

type Action =
  | FetchIssueOverrideTagsAction
  | ClearIssueOverrideTagsAction
  | RemoveIssueOverrideTagAction
  | UpdateIssueOverrideTagAction;

export default function issueOverrideTagsReducer(
  state: MaybeUninitialised<IssueOverrideTag[]> = UNINITIALISED,
  action: Action,
) {
  switch (action.type) {
    case ActionTypes.ISSUE_OVERRIDE_TAGS_FETCH.SUCCESS:
      return action.payload;
    case ActionTypes.ISSUE_OVERRIDE_TAG_REMOVE.SUCCESS:
      if (state === UNINITIALISED) {
        return state;
      }
      return state.filter(tag => tag.id !== action.payload.id);
    case ActionTypes.ISSUE_OVERRIDE_TAG_UPDATE.SUCCESS:
      if (state === UNINITIALISED) {
        return state;
      }
      return state.map(tag =>
        tag.id === action.payload.id
          ? {...tag, name: action.payload.name}
          : tag,
      );
    case ActionTypes.ISSUE_OVERRIDE_TAGS_CLEAR.SUCCESS:
    case UserActionTypes.USER_LOGOUT.SUCCESS:
      return UNINITIALISED;
    default:
      return state;
  }
}
